import Icon from './Icon';

// The expand/collapse caret used by every drill-down row (payments by supplier,
// analysis by supplier/branch/product). One chevron that rotates, rather than
// swapping two different glyphs: the rotation shows the row is the same control
// in two states, and it animates.
//
// Collapsed points LEFT — the forward direction in this RTL app — and open
// points down. Sits in the row's text flow, so it inherits the row's color
// unless `muted` is set.
export default function ExpandCaret({ open, size = 13, muted = true }) {
  return (
    <Icon
      name="chevron"
      size={size}
      className="expand-caret"
      style={{
        transform: open ? 'none' : 'rotate(90deg)',
        color: muted ? '#94a3b8' : undefined,
      }}
    />
  );
}
